import React from "react";

const ArrowRight = ({ height = 14.56, width = 8.84, color = "#fff" }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 8.836 14.56"
      >
        <path
          id="chevron-right-solid"
          d="M36.1,45.5l-6.48,6.48a.8.8,0,0,1-1.132,0l-.756-.756a.8.8,0,0,1,0-1.13l5.135-5.16-5.135-5.16a.8.8,0,0,1,0-1.13l.756-.756a.8.8,0,0,1,1.132,0l6.48,6.48A.8.8,0,0,1,36.1,45.5Z"
          transform="translate(-27.494 -37.657)"
          fill={color}
        />
      </svg>
    </>
  );
};
export default ArrowRight;
